import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/success.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-455cc624"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = { class: "payment-box" };
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1); });
var _hoisted_5 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "tip" }, "支付成功", -1); });
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "info-list-title" }, "支付信息", -1); });
var _hoisted_7 = { class: "info-list-item" };
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "info-title" }, "购买产品", -1); });
var _hoisted_9 = { class: "into-value" };
var _hoisted_10 = { class: "info-list-item" };
var _hoisted_11 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "info-title" }, "支付金额", -1); });
var _hoisted_12 = { class: "into-value" };
var _hoisted_13 = { class: "info-list-item" };
var _hoisted_14 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "info-title" }, "购买时间", -1); });
var _hoisted_15 = { class: "into-value" };
var _hoisted_16 = /*#__PURE__*/ _createTextVNode("去签字");
var _hoisted_17 = { class: "overlay-wrapper" };
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import Esign from "@/components/esign.vue";
import { signName } from "@/api";
import { Toast } from "vant";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PaymentSuccess',
    setup: function (__props) {
        var router = useRouter();
        var route = useRoute();
        var esignVisible = ref(false);
        var esignImgUrl = ref("");
        var loadingVisible = ref(false);
        var handleSubmit = function () {
            esignVisible.value = true;
            // router.push({
            //   path: "/information-binding",
            //   query: {
            //     orderNo: route.query.orderNo,
            //   },
            // });
        };
        var handleOk = function (imgUrl) {
            esignImgUrl.value = imgUrl;
            loadingVisible.value = true;
            signName(route.query.orderNo, esignImgUrl.value)
                .then(function (res) {
                esignVisible.value = false;
                if (res.code === 200) {
                    router.push({
                        path: "/information-binding",
                        query: {
                            orderNo: route.query.orderNo,
                        },
                    });
                }
                else {
                    Toast(res.message);
                }
            })
                .finally(function () {
                loadingVisible.value = false;
            });
        };
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_button = _resolveComponent("van-button");
            var _component_van_loading = _resolveComponent("van-loading");
            var _component_van_overlay = _resolveComponent("van-overlay");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_nav_bar, {
                    title: "支付成功",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).go(-1)); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_component_van_icon, {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _hoisted_5,
                        _createElementVNode("div", {
                            class: "",
                            style: _normalizeStyle({ marginTop: '1.7rem' })
                        }, [
                            _hoisted_6,
                            _createElementVNode("p", _hoisted_7, [
                                _hoisted_8,
                                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(route).query.skuName), 1)
                            ]),
                            _createElementVNode("p", _hoisted_10, [
                                _hoisted_11,
                                _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(route).query.orderPrice), 1)
                            ]),
                            _createElementVNode("p", _hoisted_13, [
                                _hoisted_14,
                                _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(route).query.payTime), 1)
                            ])
                        ], 4)
                    ]),
                    _createVNode(_component_van_button, {
                        class: "submit-btn",
                        style: _normalizeStyle({ marginTop: '0.32rem' }),
                        block: "",
                        round: "",
                        onClick: handleSubmit
                    }, {
                        default: _withCtx(function () { return [
                            _hoisted_16
                        ]; }),
                        _: 1
                    }, 8, ["style"])
                ]),
                (esignVisible.value)
                    ? (_openBlock(), _createBlock(Esign, {
                        key: 0,
                        onCancel: _cache[1] || (_cache[1] = function ($event) { return (esignVisible.value = false); }),
                        onOk: handleOk
                    }))
                    : _createCommentVNode("", true),
                _createVNode(_component_van_overlay, {
                    show: loadingVisible.value,
                    style: { zIndex: 100 }
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_van_loading, {
                                color: "#0094ff",
                                size: "24px",
                                vertical: ""
                            })
                        ])
                    ]; }),
                    _: 1
                }, 8, ["show"])
            ]));
        };
    }
});
